// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"167":"ae36287cef517532d998","464":"cfba99d805404a17c454"}[chunkId] + ".js";
};